/// <reference path="../types/index.d.ts" />

import '../client_forms/culinaryteam1/style.css';
import FormStructure from './culinaryteam1/form_structure';

export default FormStructure;